import { ReduxAsyncActionsService } from '../../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import { GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS } from '../actions/getSANAdPartnerZeitStatus';
import { INIT_STATE } from './Reddit.constants';
import type { RedditState } from './Reddit.types';
import { GET_REDDIT_AD_ACCOUNTS, GET_REDDIT_AUTHENTICATION_URL } from './actions';
import type { RedditAction } from './actions';

function handler(state: WrappedReducer<RedditState>, action: RedditAction): WrappedReducer<RedditState> {
  switch (action.type) {
    case GET_REDDIT_AD_ACCOUNTS.response:
      const { accounts } = action.data;
      return {
        ...state,
        adAccounts: accounts,
        loading: false,
      };

    case GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS.response:
      const { a_reddit } = action.data || {};
      return {
        ...state,
        adAccountStatuses: a_reddit,
        loading: false,
      };

    case GET_REDDIT_AUTHENTICATION_URL.response:
      const { url } = action.data;
      return {
        ...state,
        authenticationUrl: url,
        loading: false,
      };

    default:
      return state;
  }
}

const Reddit = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [GET_REDDIT_AD_ACCOUNTS, GET_REDDIT_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  error: [GET_REDDIT_AD_ACCOUNTS, GET_REDDIT_AUTHENTICATION_URL, GET_SAN_PARTNERS_GET_AD_ACCOUNT_ZEIT_STATUS],
  resetOn: ['APP_CHANGE'],
});

export default Reddit;
